import { render, staticRenderFns } from "./ApiWebAuthorize.vue?vue&type=template&id=4a23f82b&scoped=true"
import script from "./ApiWebAuthorize.vue?vue&type=script&lang=js"
export * from "./ApiWebAuthorize.vue?vue&type=script&lang=js"
import style0 from "./ApiWebAuthorize.vue?vue&type=style&index=0&id=4a23f82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23f82b",
  null
  
)

export default component.exports